import { render, staticRenderFns } from "./ModalCustomer.vue?vue&type=template&id=01663ef1&scoped=true&"
import script from "./ModalCustomer.vue?vue&type=script&lang=js&"
export * from "./ModalCustomer.vue?vue&type=script&lang=js&"
import style0 from "./ModalCustomer.vue?vue&type=style&index=0&id=01663ef1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01663ef1",
  null
  
)

export default component.exports